import React from "react";
import Navbar from "../src/Components/Navbar.jsx";

function App() {
  return (
    <div className="App">
      <Navbar />
    </div>
  );
}

export default App;
